export default __webpack_public_path__ + "static/media/SolutionsOutpost.4d908288.png";